(() => {
  const show = (el) => { if (el) el.style.display = ''; };
  const hide = (el) => { if (el) el.style.display = 'none'; };

  function parseVariantsJson(productFormEl) {
    const jsonEl = productFormEl.querySelector('script[data-product-variants]');
    if (!jsonEl) { return []; }
    try {
      const v = JSON.parse(jsonEl.textContent || '[]');
      return v;
    } catch (e) {
      return [];
    }
  }

  function getVariantById(variants, id) {
    const num = Number(id);
    return variants.find(v => Number(v.id) === num) || null;
  }

  function isOOSVariant(variant) {
    return variant ? variant.available === false : false;
  }

  function initOne(pfc) {
    const variantInput =
      pfc.querySelector('input[name="id"][ref="variantId"]') ||
      pfc.querySelector('input[name="id"]');

    const qtyWrapper =
        pfc.querySelector('.quantity-selector-wrapper') ||
        pfc.querySelector('[ref="quantitySelectorWrapper"]');

    const atcBtn = pfc.querySelector('button[name="add"]');
    const notifyBox = pfc.querySelector('[data-notify-me-box]');

    if (!variantInput || !atcBtn || !notifyBox) return;

    const endpoint = notifyBox.getAttribute('data-notify-endpoint') || '';
    const variants = parseVariantsJson(pfc);

    const productInput = notifyBox.querySelector('input[name="product"]');

    function updateUI(reason) {
      const variantId = variantInput.value;
      const variant = getVariantById(variants, variantId);

      if (productInput) productInput.value = variant?.name || variant?.title || String(variantId || '');

      const oos = isOOSVariant(variant);
        if (oos) { 
            hide(atcBtn);
            if (qtyWrapper) hide(qtyWrapper);          // <-- aqui
            show(notifyBox);
        } else {
            show(atcBtn);
            if (qtyWrapper) show(qtyWrapper);          // <-- aqui
            hide(notifyBox);
        }
    }

    // IMPORTANTÍSSIMO: Horizon pode atualizar via propriedade .value
    // então usamos:
    // 1) change capturado do variant-picker
    document.addEventListener('change', (e) => {
      const vp = e.target && e.target.closest && e.target.closest('variant-picker');
      if (!vp) return;

      const sameSection =
        vp.getAttribute('data-section-id') &&
        vp.getAttribute('data-section-id') === pfc.getAttribute('data-section-id');

      if (!sameSection) return;

      setTimeout(() => updateUI('variant-picker change'), 0);
    }, true);

    // 2) poll fallback (pra ver o id mudando com certeza)
    let last = variantInput.value;
    setInterval(() => {
      if (variantInput.value !== last) {
        last = variantInput.value;
        updateUI('poll');
      }
    }, 250);

    updateUI('init');
  }

  function init() {
    const forms = Array.from(document.querySelectorAll('product-form-component'));
    forms.forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
document.addEventListener(
  'click',
  async (e) => {
    const btn = e.target?.closest?.('[data-notify-submit]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    console.log('[notify-me] click submit captured', btn);

    const notifyBox = btn.closest('[data-notify-me-box]');
    if (!notifyBox) {
      console.warn('[notify-me] notifyBox não encontrado a partir do botão');
      alert('Erro: formulário não encontrado.');
      return;
    }

    const pfc = btn.closest('product-form-component') || document;
    const variantInput =
      pfc.querySelector('input[name="id"][ref="variantId"]') ||
      pfc.querySelector('input[name="id"]');

    const endpoint = notifyBox.getAttribute('data-notify-endpoint') || '';
    const nameInput = notifyBox.querySelector('input[name="name"]');
    const emailInput = notifyBox.querySelector('input[name="email"]');
    const productInput = notifyBox.querySelector('input[name="product"]');
    const successEl = notifyBox.querySelector('[data-notify-success]');
    const rowEl = notifyBox.querySelector('.notify-me-row');
    const titleEl = notifyBox.querySelector('.notify-me-title');
    const subtitleEl = notifyBox.querySelector('.notify-me-subtitle');

    const name = (nameInput?.value || '').trim();
    const email = (emailInput?.value || '').trim();
    const product = (productInput?.value || '').trim();
    const variantId = variantInput?.value || '';

    console.log('[notify-me] payload fields', { name, email, product, variantId });

    if (!name || !email || !product) {
      alert('Por favor, preencha nome, e-mail e selecione uma variante válida.');
      return;
    }

    btn.disabled = true;

    try {
      // Envio via edrone (SDK carregado na página via GTM). O produto vai como
      // tag pra segmentar no edrone (ex.: "avise-me;Camisa X-Tretch - Preto / G").
      window._edrone = window._edrone || {};
      if (!window._edrone.app_id) window._edrone.app_id = 'a9cbd31594bda';

      // tag única no formato "avise-me:<nome do produto>" (sem a variante)
      const productTitle = (notifyBox.getAttribute('data-product-title') || product || '').trim();

      window._edrone.first_name = name;
      window._edrone.email = email;
      window._edrone.customer_tags = 'avise-me:' + productTitle;
      window._edrone.action_type = 'subscribe';

      if (typeof window._edrone.init === 'function') {
        window._edrone.init();
      } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        // Fallback: edrone ainda não carregou — manda o evento pro GTM/dataLayer
        console.warn('[notify-me] _edrone.init indisponível, usando dataLayer fallback');
        window.dataLayer.push({ event: 'back_in_stock', email, name, product, variantId });
      } else {
        throw new Error('edrone (_edrone.init) indisponível e sem dataLayer');
      }

      // Limpa o estado do edrone pra não reenviar subscribe em ações seguintes
      window._edrone.action_type = '';

      // UI sucesso
      if (rowEl) rowEl.style.display = 'none';
      if (titleEl) titleEl.style.display = 'none';
      if (subtitleEl) subtitleEl.style.display = 'none';
      btn.style.display = 'none';
      if (successEl) successEl.style.display = 'block';

      // limpa inputs
      if (nameInput) nameInput.value = '';
      if (emailInput) emailInput.value = '';

    } catch (error) {
      console.error('[notify-me] erro no envio', error);
      alert('Não foi possível enviar agora. Tente novamente.');
    } finally {
      btn.disabled = false;
    }
  },
  true // capture: evita outros handlers engolirem
);